const updateSubmissionsReportDateRange = function ({ commit }, payload) {
  commit("SET_SUBMISSION_REPORT_DATE_RANGE", payload);
};

export default updateSubmissionsReportDateRange;
